import { PapiUser } from '@wix/da-papi-types';
import { createAction } from 'redux-actions';
import { actionKey } from './constants';

export const requestJoinGroup = createAction(`${actionKey}.REQUEST_JOIN`, (group: PapiUser) => ({
  group,
}));
export const requestLeaveGroup = createAction(`${actionKey}.REQUEST_LEAVE`, (group: PapiUser) => ({
  group,
}));
export const groupJoinSuccess = createAction(`${actionKey}.JOIN_SUCCESS`, (group: PapiUser) => ({
  group,
}));
export const groupJoinFail = createAction(
  `${actionKey}.JOIN_FAIL`,
  (group: PapiUser, error: string) => ({ group, error })
);
export const groupJoinPending = createAction(`${actionKey}.JOIN_PENDING`, (group: PapiUser) => ({
  group,
}));
export const groupLeaveSuccess = createAction(`${actionKey}.LEAVE_SUCCESS`, (group: PapiUser) => ({
  group,
}));
export const groupLeaveFail = createAction(
  `${actionKey}.LEAVE_FAIL`,
  (group: PapiUser, error: string) => ({ group })
);
export const sendAdminNote = createAction(
  `${actionKey}.SEND_ADMIN_NOTE`,
  (recipientId: number, subject: string, editorRaw: any) => ({
    recipientId,
    subject,
    editorRaw,
  })
);
export const messageAdmins = createAction(`${actionKey}.MESSAGE_ADMINS`, (group: PapiUser) => ({
  group,
}));
